var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.83344V1.34177C7.5 0.966773 7.05 0.78344 6.79167 1.05011L4.45833 3.37511C4.29167 3.54177 4.29167 3.80011 4.45833 3.96677L6.78333 6.29177C7.05 6.55011 7.5 6.36677 7.5 5.99177V4.50011C10.2583 4.50011 12.5 6.74177 12.5 9.50011C12.5 10.1584 12.375 10.8001 12.1333 11.3751C12.0083 11.6751 12.1 12.0168 12.325 12.2418C12.75 12.6668 13.4667 12.5168 13.6917 11.9584C14 11.2001 14.1667 10.3668 14.1667 9.50011C14.1667 5.81677 11.1833 2.83344 7.5 2.83344ZM7.5 14.5001C4.74167 14.5001 2.5 12.2584 2.5 9.50011C2.5 8.84177 2.625 8.20011 2.86667 7.62511C2.99167 7.32511 2.9 6.98344 2.675 6.75844C2.25 6.33344 1.53333 6.48344 1.30833 7.04177C1 7.80011 0.833334 8.63344 0.833334 9.50011C0.833334 13.1834 3.81667 16.1668 7.5 16.1668V17.6584C7.5 18.0334 7.95 18.2168 8.20833 17.9501L10.5333 15.6251C10.7 15.4584 10.7 15.2001 10.5333 15.0334L8.20833 12.7084C7.95 12.4501 7.5 12.6334 7.5 13.0084V14.5001Z",
    fill: "#51CF66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncOn);
export default __webpack_public_path__ + "static/media/sync-on.a6c6a7eda8b094527a2153c2da5d3d49.svg";
export { ForwardRef as ReactComponent };